import type { ReactNode } from "react";
import { useI18n } from "@wato/i18n/react";
import { Icon } from "../../rtl/glyphs";
import { IconButton } from "../IconButton/IconButton";
import { Popover } from "../Popover/Popover";

export interface HelpPopoverProps {
  readonly title?: string;
  readonly children: ReactNode;
  /** Extra footer content, e.g. a help-article link. */
  readonly footer?: ReactNode;
  readonly label?: string;
  readonly placement?: "start" | "end";
  readonly testId?: string;
}

/** `?` icon button that opens the explanation (anchored popover; bottom sheet on phones). */
export function HelpPopover({
  title,
  children,
  footer,
  label,
  placement,
  testId = "help-popover",
}: HelpPopoverProps) {
  const { t } = useI18n();
  const name = label ?? title ?? t("ui.help.label");
  return (
    <Popover
      label={name}
      placement={placement}
      testId={testId}
      panelClassName="w-72"
      trigger={(p) => (
        <IconButton
          {...p}
          label={label ?? t("ui.help.label")}
          icon={<Icon name="help" />}
          variant="ghost"
        />
      )}
    >
      <div className="flex flex-col gap-2">
        {title && <p className="font-semibold">{title}</p>}
        <div className="text-fg-muted">{children}</div>
        {footer}
      </div>
    </Popover>
  );
}
